import { QueryKeyConfig, MutationKeyConfig } from './api-helper';

export interface NoteListRequestArgs {
  projectID?: number;
  officeID?: number;
  customerID?: number;
  workOrderID?: number;
  unitID?: number;
  noteTempEntityID?: number;
  planReviewTaskID?: number;
}

const getNoteQueryStrings = (args: NoteListRequestArgs) => {
  if (args.customerID) {
    return `customerID=${args.customerID}`;
  }
  if (args.officeID) {
    return `officeID=${args.officeID}`;
  }
  if (args.projectID) {
    return `projectID=${args.projectID}`;
  }
  if (args.unitID) {
    return `unitID=${args.unitID}`;
  }
  if (args.workOrderID) {
    return `WorkOrderID=${args.workOrderID}`;
  }
  if (args.planReviewTaskID) {
    return `planReviewTaskID=${args.planReviewTaskID}`;
  }
  if (args.noteTempEntityID) {
    return `noteTempEntityID=${args.noteTempEntityID}`;
  }
};

export const noteApiKeyStore = {
  createNote: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_NOTE`],
    route: `/Note`,
    action: 'POST',
  }),
  updateNote: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_NOTE`],
    route: `/Note`,
    action: 'PUT',
  }),
  deleteNote: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_NOTE`, id],
    route: `/Note/${id}`,
    action: 'DELETE',
  }),
  getNotes: (args: NoteListRequestArgs): QueryKeyConfig => ({
    queryKey: [
      `GET_NOTES`,
      ...[args.customerID, args.noteTempEntityID, args.officeID, args.projectID, args.unitID, args.workOrderID, args.planReviewTaskID].filter(
        (a) => a
      ),
    ],
    route: `/Note?${getNoteQueryStrings(args)}`,
    isEnabled:
      !!args &&
      (!!args.customerID ||
        !!args.officeID ||
        !!args.projectID ||
        !!args.noteTempEntityID ||
        !!args.unitID ||
        !!args.workOrderID ||
        !!args.planReviewTaskID),
  }),
};
